export const CATALOGUE_PAGE_TYPE = {
    TRENDING: 'trending',
    DEALS: 'deals',
    CATEGORY: 'category',
    SUBCATEGORY: 'subcategory',
};
